import { useCallback, useEffect, useRef, useState } from "@";
import { usePagination } from "./usePagination";

// Hook for fetching data with pagination and error handling
export const useFetchData = ({
  fun,
  id = null,
  params = [],
  fill = null,
  reset = null,
  noPgn = false,
  setDataValue = false,
}) => {
  const [data, setData] = useState([]);
  const hasFetchedData = useRef(false);
  const { pg, updatePg } = usePagination();
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = useCallback(
    async (page = pg.page, size = pg.size) => {
      hasFetchedData.current = true;
      !hasFetchedData.current && setIsLoading(true);
      try {
        let result;
        if (id) {
          result = await fun(id);
        } else if (!reset && !fill) {
          if (!noPgn) {
            result = await fun(page, size, ...params);
          } else {
            result = await fun(...params);
          }
        } else {
          result = await fun();
        }

        const { data: values } = result || {};
        if (reset) {
          reset(fill ? fill(values) : values);
        } else if (fill) {
          setDataValue ? setData(fill(values)) : fill(values);
        } else {
          setData(result?.data?.data || result?.data || result);
          if (!noPgn && !id) {
            updatePg({ rows: values.totalItems, page });
          }
        }
        setError(false);
      } catch (err) {
        console.error("useFetchData error:", err);
        setError(true);
      }
      setIsLoading(false);
    },
    [
      id,
      fun,
      fill,
      reset,
      noPgn,
      params,
      pg.page,
      pg.size,
      updatePg,
      setDataValue,
    ],
  );

  useEffect(() => {
    fetchData();
  }, [pg.page, pg.size, id]);

  return { data, isLoading, error, pg, fetchData, updatePg, setData, setError };
};
